interface Price {
    amount: number;
    currency: string;
}
export interface Entry {
    enteredDate: string;
    status: string;
    orderId: number;
    description: string;
    type: string;
    amount: number;
}

export interface ExchangeRateExample {
    rate: Price;
    exampleOrderPrice1: Price;
    exampleOrderPoints1: number;
    exampleOrderPrice2: Price;
    exampleOrderPoints2: number;
    thresholdAmount: Price;
}

export interface ExchangeRateExampleServiceResponse {
    data: ExchangeRateExample;
}

export interface EntryServiceResponse {
    data: Entry[];
}

export enum ViewType { Public = 'public', Private = 'private' }
export enum SortingMode { Desc = 'desc', Asc = 'asc' }
